"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDepositCurrentBonus = void 0;
var react_1 = require("react");
var keys_1 = require("../keys");
var useGlobalState_1 = require("./useGlobalState");
var useDepositCurrentBonus = function () {
    var _a = (0, useGlobalState_1.useGlobalState)(keys_1.globalStateKeys.DEPOSIT_CURRENT_BONUS, null), state = _a.state, changeState = _a.changeState;
    return (0, react_1.useMemo)(function () { return ({
        depositCurrentBonus: state,
        changeDepositCurrentBonus: changeState,
    }); }, [state, changeState]);
};
exports.useDepositCurrentBonus = useDepositCurrentBonus;
